import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { Router } from '@angular/router';
import { EventManager } from 'src/app/core';
import { UpdateNavPopupComponent } from '../update-nav-popup/update-nav-popup.component';
import { ToastrService } from 'ngx-toastr';
import { ProductService } from '../../product.service';
import { ManageComponent } from 'src/app/shared/components/manage.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { createRequestBody } from 'src/app/shared/util';
@Component({
  selector: 'app-sip-list',
  templateUrl: './sip-list.component.html',
  styleUrls: ['./sip-list.component.scss']
})
export class SipListComponent extends ManageComponent implements OnInit {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  setting: any = {};
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    private productService: ProductService,
    public modalService: NzModalService,
    private toastService: ToastrService
  ) {
    super(eventManager, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    req = req || this.queryParams;
    this.list = [];
    let body: any = createRequestBody(req);
    return this.productService.querySIP(body)
    .subscribe(this.onResponse.bind(this));
  }
  afterSuccess(response) {
    this.list.forEach((item) => {
      (item.productNavInDtoList || []).forEach((product) => {
        if (product.percent <= 96 || product.percent >= 104) {
          product.isHighligt = true;
        }
      })
    });
  }
  create() {
    this.router.navigate(['/products/sip/create']);
  }
  edit(id) {
    this.router.navigate(['/products/sip/edit/' + id]);
  }
  transferFee(item) {
    item.productProgram = item.productProgram || {};
    this.router.navigate(['products/sip/fee-transfer/' + (item.productProgram.product || {}).id + '/' + item.productProgram.id+ '/' + item.productProgram.name]);
  }
  openPopupNAV() {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzOkDisabled: true,
      nzContent: UpdateNavPopupComponent,
      nzFooter: null,
      nzData: {
      },
      nzOnOk: (() => { })
    });
  }
  updateConfig() {
    this.productService.editConfig(this.setting)
    .subscribe((res) => {
      this.toastService.success('Sửa thuế thành công!');
    })
  }
  delete() {
    this.productService.deleteProgram(this.selectedItem.id)
    .subscribe((res) => {
      this.toastService.success('Xóa chương trình Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmDelete(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn xóa chương trình : ${selectedItem.sipCode}`, this.delete.bind(this));
  }
  addNewFee(item) {
    this.router.navigate(['products/sip/new-fee/' + item.productProgram.product.id + '/' + item.id]);
  }
}
